import axios from 'axios';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

console.log('API URL:', process.env.REACT_APP_API_URL);

API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const teacherAPI = {
    getMyClasses: () => API.get('/teacher/my-classes'),
    getNews: () => API.get('/news'),
    getAttendace: () => API.get('/teacher/attendance-graph'),
    getStudents: () => API.get('/teacher/my-students'),
    getAulaToday: () => API.get('/aula/today'),
    getStudentProgress: () => API.get('/aula/follow'),
    getGraphWeekly: () => API.get('/aula/weekly-graph'),
};